import { request } from '@/shared/api/request'

export const sendSignedProfUnions = (data, isEmployee = false, myTradeUnion = true) => {
	return request({
		url: `colcontract/tradeUnion/sign?isEmployee=${isEmployee}&myTradeUnion=${myTradeUnion}`,
		method: 'POST',
		data: data,
	})
}
